import {createFileRoute, Outlet} from '@tanstack/react-router';
import {useDepositOnboarding} from 'features/deposit/onboarding/hooks';

const DepositOnboardingLayout = () => {
  useDepositOnboarding();
  return <Outlet />;
};

export const Route = createFileRoute('/_protected/deposit-onboarding')({
  component: DepositOnboardingLayout,
});
